import Image from "next/image";
import { pxToRem } from "@ui/lib/utils";

export default function CountryFlag({
  countryCode,
  size = 24,
  className,
  alt = "",
}: {
  alt?: string;
  className?: string;
  countryCode: string;
  size?: number;
}) {
  const sizeInRem = pxToRem(size);

  return (
    <Image
      alt={alt}
      className={className}
      height={512}
      src={`https://eleven-public-cdn.elevenlabs.io/images/flags/circle-flags/${countryCode.toLowerCase()}.svg`}
      style={{
        width: sizeInRem,
        height: sizeInRem,
      }}
      width={512}
    />
  );
}
